import React, { useState } from 'react';
import { FaPlus } from 'react-icons/fa';
import { Switch, Route, useRouteMatch, useHistory } from 'react-router-dom';

import { createIconFromImage } from 'helper';
import Button from 'partial/components/Button';
// import FormToggle from 'partial/form/FormToggle';
import Pagination from 'partial/components/Pagination';
import { useCreateModal } from 'partial/components/Modal';
import Table, { tableEditDelete } from 'partial/components/Table';
import ConfirmationModal from 'partial/components/modals/ConfirmationModal';
import deleteAccountIcon from 'assets/images/icons/icon-delete-account.png';

import AddEditAclUser from '../components/AddEditAclUser';
import UserListFilter from '../components/UserListFilter';
import SelectedAclUser from '../components/SelectedAclUser';
import { useGetUserList, useDeleteUser } from '../hooks';

const DeleteAccountIcon = createIconFromImage({ url: deleteAccountIcon });

function AclUsers() {
  const match = useRouteMatch();
  const history = useHistory();
  const [filterData, setFilterData] = useState();
  const [deleteUser, isDeleteLoading] = useDeleteUser();
  const [listData, isLoading, pager] = useGetUserList(filterData);
  const modal = useCreateModal('DELETE_USER', {
    isDeleteLoading,
  });

  const tableFormat = React.useMemo(() => {
    const handleDelete = (row) => {
      modal({
        // eslint-disable-next-line
        content: (onClose) => ({ isDeleteLoading: isLoadingProp }) => (
          <ConfirmationModal
            title={`${row?.first_name || '---'} ${row?.last_name || '---'}`}
            header={`Are you sure you want to delete ${row?.first_name} ${row?.last_name}?`}
            paragraph="This action will permanently delete your data from our database. You can't undo this action."
            firstBtnLabel="Cancel"
            secondBtnLabel="Yes, Delete"
            secondBtnColor="primary"
            icon={DeleteAccountIcon}
            onSubmit={() => deleteUser(row?.id, onClose)}
            onClose={onClose}
            isLoading={isLoadingProp}
          />
        ),
      });
    };
    return [
      {
        label: 'Team Member',
        key: (row) => (
          <span>
            {row?.first_name} {row?.last_name}
          </span>
        ),
        id: 'team_member',
        width: '20%',
      },
      { label: 'Email', key: 'email', id: 'email', width: '20%' },
      { label: 'Role', key: 'role', id: 'role', width: '15%' },
      {
        label: 'Biller Name',
        key: (row) =>
          row?.role === 'Organization Admin' ? (
            '-'
          ) : (
            <span>{row?.biller_name}</span>
          ),
        id: 'biller_name',
        width: '20%',
      },
      {
        label: 'Last Login',
        key: (row) => {
          if (row?.last_login) return row?.last_login?.replace(/-/g, '/');
          return '-';
        },
        id: 'last_login',
        width: '14%',
      },
      tableEditDelete(
        (row) =>
          history.push(`${match.path}/${row?.id}/view`, {
            initValues: row,
          }),
        (row) =>
          history.push(`${match.path}/${row?.id}/edit`, {
            initValues: row,
          }),
        handleDelete
      ),
    ];
  }, [history, match, deleteUser, modal]);

  return (
    <div className="bg-white rounded-xl flex flex-col flex-1 m-5">
      <Switch>
        <Route path={`${match.path}/add`} component={AddEditAclUser} />
        <Route path={`${match.path}/:id`} component={SelectedAclUser} />
        <Route>
          <div className="flex items-center border-b mx-6 mt-6 pb-6">
            <UserListFilter onSubmit={setFilterData} isLoading={isLoading} />
            <div className="flex justify-end w-72">
              <Button
                type="button"
                primary
                icon={FaPlus}
                onClick={() => history.push(`${match.path}/add`)}
              >
                Add New Member
              </Button>
            </div>
          </div>
          <div className="flex flex-1 px-6 pb-6">
            <Table
              data={listData?.data}
              isLoading={isLoading}
              format={tableFormat}
            />
          </div>
          <div className="flex justify-end p-2">
            <Pagination small onChange={setFilterData} data={pager} />
          </div>
        </Route>
      </Switch>
    </div>
  );
}

export default AclUsers;
